import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRef, useState } from "react";
import { useMutation } from "@apollo/client";
import { useAmplitude } from "@crehana/analytics";
import { customLocalStorage, getNextUrl } from "@crehana/utils";
import { sendRegisterTrackToGoogleAdsAndAnalytics } from "../../utils";
var SOCIAL_LOGIN_MUTATION = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "AuthFormSocialloginMutation"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "backend"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "token"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "isJwtAuth"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Boolean"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "nextUrl"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "giftcardToken"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "referFriendId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "ID"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "friendInvitationId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "ID"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "upperFunnelSource"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "UpperFunnelSourceEnum"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "upperFunnelJobToBeDone"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "UpperFunnelJobToBeDoneEnum"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "upperFunnelUrlSource"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "newsLetterCheckbox"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Boolean"
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "socialLogin"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "ObjectValue",
            fields: [{
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "backend"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "backend"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "token"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "token"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "nextUrl"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "nextUrl"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "giftcardToken"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "giftcardToken"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "referFriendId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "referFriendId"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "friendInvitationId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "friendInvitationId"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "isJwtAuth"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "isJwtAuth"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "upperFunnelSource"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "upperFunnelSource"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "upperFunnelJobToBeDone"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "upperFunnelJobToBeDone"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "upperFunnelUrlSource"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "upperFunnelUrlSource"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "newsLetterCheckbox"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "newsLetterCheckbox"
                }
              }
            }]
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "success"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "redirect"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "isNewUser"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "jwtToken"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "token"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "refreshToken"
                },
                arguments: [],
                directives: []
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 899,
    source: {
      body: "mutation AuthFormSocialloginMutation(\n  $backend: String!\n  $token: String!\n  $isJwtAuth: Boolean\n  $nextUrl: String\n  $giftcardToken: String\n  $referFriendId: ID\n  $friendInvitationId: ID\n  $upperFunnelSource: UpperFunnelSourceEnum\n  $upperFunnelJobToBeDone: UpperFunnelJobToBeDoneEnum\n  $upperFunnelUrlSource: String\n  $newsLetterCheckbox: Boolean\n) {\n  socialLogin(\n    input: {\n      backend: $backend\n      token: $token\n      nextUrl: $nextUrl\n      giftcardToken: $giftcardToken\n      referFriendId: $referFriendId\n      friendInvitationId: $friendInvitationId\n      isJwtAuth: $isJwtAuth\n      upperFunnelSource: $upperFunnelSource\n      upperFunnelJobToBeDone: $upperFunnelJobToBeDone\n      upperFunnelUrlSource: $upperFunnelUrlSource\n      newsLetterCheckbox: $newsLetterCheckbox\n    }\n  ) {\n    success\n    redirect\n    isNewUser\n    jwtToken {\n      token\n      refreshToken\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
};
import loadGoogleAndFacebookScripts from "./utils";
export var googleFallbackUrl = '/login/google-oauth2/';
export var facebookFallbackUrl = '/login/facebook/';
var idCounter = 0;
var genId = function genId() {
  idCounter += 1;
  return idCounter;
};
export var useSocialAuth = function useSocialAuth(_ref) {
  var friendInvitationId = _ref.friendInvitationId,
    referFriendId = _ref.referFriendId,
    nextUrlProp = _ref.nextUrl,
    onSuccess = _ref.onSuccess,
    onFinishToLoadScripts = _ref.onFinishToLoadScripts,
    getNextUrlProp = _ref.getNextUrl,
    isJwtAuth = _ref.isJwtAuth,
    hideFacebookLink = _ref.hideFacebookLink,
    _ref$newsLetterCheckb = _ref.newsLetterCheckbox,
    newsLetterCheckbox = _ref$newsLetterCheckb === void 0 ? false : _ref$newsLetterCheckb;
  var _useAmplitude = useAmplitude(),
    logEvent = _useAmplitude.logEvent;
  var gmailButtonRef = useRef(null);
  var gmailHTMLButtonId = useRef("customGoogleButton-".concat(genId()));
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    processingSocialAuth = _useState2[0],
    setProcessingSocialAuth = _useState2[1];
  var _useMutation = useMutation(SOCIAL_LOGIN_MUTATION, {
      context: {
        clientName: 'auth'
      }
    }),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    socialLogin = _useMutation2[0];
  var googleApiAuthRef = useRef();
  var _useState3 = useState({
      loadingFacebookAndGoogleScripts: false,
      errorToLoadFacebookAndGoogleScripts: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    state = _useState4[0],
    setState = _useState4[1];
  var _getNextUrl = function _getNextUrl() {
    if (getNextUrlProp) {
      return getNextUrlProp();
    }
    return nextUrlProp || getNextUrl();
  };
  var nextUrl = _getNextUrl();
  var redirectToFacebookLoginPage = function redirectToFacebookLoginPage() {
    window.location.href = "".concat(facebookFallbackUrl, "?next=").concat(nextUrl);
  };
  var redirectToGoogleLoginPage = function redirectToGoogleLoginPage() {
    window.location.href = "".concat(googleFallbackUrl, "?next=").concat(nextUrl);
  };
  var login = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var token, backend, source, redirectToFallbackUrl, _response$data, _response$data$social, response, _response$data$social2, redirect, isNewUser;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            token = _ref2.token, backend = _ref2.backend, source = _ref2.source;
            redirectToFallbackUrl = backend === 'facebook' ? redirectToFacebookLoginPage : redirectToGoogleLoginPage;
            _context.prev = 2;
            setProcessingSocialAuth(true);
            _context.next = 6;
            return socialLogin({
              variables: {
                isJwtAuth: isJwtAuth,
                token: token,
                nextUrl: nextUrl,
                backend: backend,
                referFriendId: referFriendId,
                friendInvitationId: friendInvitationId,
                newsLetterCheckbox: newsLetterCheckbox
              }
            });
          case 6:
            response = _context.sent;
            setProcessingSocialAuth(false);
            if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$social = _response$data.socialLogin) !== null && _response$data$social !== void 0 && _response$data$social.success) {
              _response$data$social2 = response.data.socialLogin, redirect = _response$data$social2.redirect, isNewUser = _response$data$social2.isNewUser;
              if (isNewUser) {
                sendRegisterTrackToGoogleAdsAndAnalytics();
              } else {
                logEvent({
                  event: 'Successful SignIn',
                  data: {
                    source: source
                  }
                });
              }
              onSuccess({
                redirect: redirect,
                isNewUser: isNewUser,
                graphqlResponse: response.data.socialLogin
              });
            } else {
              redirectToFallbackUrl();
            }
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            redirectToFallbackUrl();
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 11]]);
    }));
    return function login(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var attachSignin = function attachSignin(element) {
    if (!element || !googleApiAuthRef.current) {
      return;
    }
    googleApiAuthRef.current.attachClickHandler(element, {}, function (googleUser) {
      login({
        token: googleUser.getAuthResponse(true).access_token,
        backend: 'google-oauth2',
        source: 'Google'
      });
    }, function (error) {
      console.error('Google error auth', error);
      redirectToGoogleLoginPage();
    });
  };
  var initializeGoogle = function initializeGoogle() {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (process.env.NODE_ENV === 'production' && window.location.origin.includes('crehana.com')) window.gapi.load('auth2', function () {
      // Retrieve the singleton for the GoogleAuth library and set up the client.

      googleApiAuthRef.current = window.gapi.auth2.init({
        client_id:
        // @ts-expect-error this global is only present in crehana-jsx
        window.GLOBAL_GOOGLE_CLIENT_ID || process.env.NEXT_PUBLIC_SOCIAL_AUTH_GOOGLE_OAUTH2_KEY,
        cookie_policy: 'single_host_origin'
        // Request scopes in addition to 'profile' and 'email'
        // scope: 'additional_scope'
      });
      attachSignin(gmailButtonRef.current);
    });
  };
  var loginWithFacebook = function loginWithFacebook() {
    // RemoveConditionThatPreventsContinueWithFacebookFloatingButtonToBeShown
    customLocalStorage.removeItem('CREH__continueAsFacebookUserDialog');
    if (hideFacebookLink) {
      redirectToFacebookLoginPage();
      return;
    }
    if (window.FB) {
      window.FB.getLoginStatus(function (facebookLoginStatus) {
        var backend = 'facebook';
        if (facebookLoginStatus.status === 'connected') {
          var token = facebookLoginStatus.authResponse.accessToken;
          login({
            token: token,
            backend: backend,
            source: 'Facebook'
          });
        } else {
          window.FB.login(function (loginResponse) {
            if (loginResponse.authResponse) {
              var _token = loginResponse.authResponse.accessToken;
              login({
                token: _token,
                backend: backend,
                source: 'Facebook'
              });
            } else {
              redirectToFacebookLoginPage();
            }
          }, {
            scope: 'email'
          });
        }
      });
    }
  };
  function setupAndInitSocialAuthScripts() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      loadingFacebookAndGoogleScripts: true
    }));
    loadGoogleAndFacebookScripts().then(function () {
      if (onFinishToLoadScripts) {
        onFinishToLoadScripts(true);
      }
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          errorToLoadFacebookAndGoogleScripts: false,
          loadingFacebookAndGoogleScripts: false
        });
      });
      initializeGoogle();
    })["catch"](function (error) {
      console.error('Errot to load the facebook and google skd', error);
      if (onFinishToLoadScripts) {
        onFinishToLoadScripts(false);
      }
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          errorToLoadFacebookAndGoogleScripts: true,
          loadingFacebookAndGoogleScripts: false
        });
      });
    });
  }
  return {
    setupAndInitSocialAuthScripts: setupAndInitSocialAuthScripts,
    authState: _objectSpread(_objectSpread({}, state), {}, {
      processingSocialAuth: processingSocialAuth
    }),
    gmailButtonProps: {
      id: gmailHTMLButtonId.current,
      ref: gmailButtonRef
    },
    facebookButtonProps: {
      onClick: loginWithFacebook
    }
  };
};